const question1 = {
    'question': 'Jaki jest koszt całej diagnostyki autyzmu?',
    'answer': 'Cena diagnostyki autyzmu w naszym centrum w Toruniu to 2070 zł. Proces diagnostyki autyzmu jest złożony z wielu etapów, które mogą być również realizowane oddzielnie. W celu zapoznania się z poszczególnymi etapami i ich kosztem zachęcamy do kontaktu telefonicznego z naszą rejestracją.',
}

export default question1;